import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { store } from "./redux/store";
import { handleRTL } from "./redux/layout";
import en from "./locales/en";
import ar from "./locales/ar";

const LANGUAGE_STORAGE_KEY = "app-language";
const DEFAULT_LANGUAGE =
  (typeof window !== "undefined" &&
    window.localStorage.getItem(LANGUAGE_STORAGE_KEY)) ||
  "en";

const isRtlLanguage = (language) => language === "ar";

const applyLanguageSettings = (language) => {
  if (typeof document === "undefined") {
    return;
  }

  const direction = isRtlLanguage(language) ? "rtl" : "ltr";
  const html = document.documentElement;

  html.setAttribute("lang", language);
  html.setAttribute("dir", direction);
  html.setAttribute("data-textdirection", direction);

  if (document.body) {
    document.body.setAttribute("data-textdirection", direction);
  }

  if (typeof window !== "undefined") {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    window.localStorage.setItem(
      "direction",
      JSON.stringify(direction === "rtl")
    );
  }

  store.dispatch(handleRTL(direction === "rtl"));
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", applyLanguageSettings);
applyLanguageSettings(DEFAULT_LANGUAGE);

export { LANGUAGE_STORAGE_KEY, applyLanguageSettings };
export default i18n;
